module.exports = __webpack_public_path__ + "static/media/jQuery.0633096d.png";